import { TFunction } from '@mint-lib/i18n';

import { Option } from '../types/campaignBuilder.js';

export const MANUAL = 'MANUAL';
export const AUTOMATIC = 'AUTOMATIC';

export const UNDERSPENDING = 'UNDERSPENDING';
export const OVERSPENDING = 'OVERSPENDING';

export const MIN_PERCENTAGE = 1;
export const MIN_FIELD_MAX_PERCENTAGE = 99;
export const MAX_PERCENTAGE = 100;

export const getI18nGoalOptions = (t: TFunction) => [
  { label: t('Media Row Main KPI Goals (default)'), value: 'mediarow' },
  { label: t('Channel Mix Main KPI Goal'), value: 'channel' },
  { label: t('Campaign Main KPI Goal'), value: 'campaign' },
];

export const getBudgetReallocationAmountOptions = (t: TFunction): Option[] => [
  {
    name: t('Automatic'),
    value: AUTOMATIC,
  },
  {
    name: t('Manual'),
    value: MANUAL,
  },
];

export const getSpendingRulesTooltips = (
  spendingRule: string,
  t: TFunction,
): { [key: string]: string } => {
  if (spendingRule === UNDERSPENDING) {
    return {
      AUTOMATIC: t(
        'The total reallocated budget could be up to 20% less of the current unspent budget',
      ),
      MANUAL: t(
        'Set value between 1% and 20%. That is the maximum your total budget could decrease',
      ),
    };
  }

  return {
    AUTOMATIC: t(
      'The total reallocated budget could be up to 20% more of the current unspent budget',
    ),
    MANUAL: t(
      'Set value between 1% and 20%. That is the maximum your total budget could increase',
    ),
  };
};

export enum BudgetLimitErrors {
  OUT_OF_RANGE = 'OUT_OF_RANGE',
  EMPTY_FIELD = 'EMPTY_FIELD',
  OUT_OF_RANGE_SPENDING_RULES = 'OUT_OF_RANGE_SPENDING_RULES',
}
